import React, { FunctionComponent, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../Header';
import { CatalogEntryType, CatalogEntryTypeMap } from '../types';
import AppliedPrototypesContainer from './AppliedPrototypesContainer'
import { useEffect } from 'react';

interface Props {}


const AppliedPrototypesPage: FunctionComponent<Props> = () => {
  const [catalogEntryType, setCatalogEntryType] = useState<CatalogEntryType>(CatalogEntryType.CLOUDERA_AMPS);
  const navigate = useNavigate(); 
  const location = useLocation();
  
  useEffect(() => {
    if (location.pathname === '/community' && catalogEntryType !== CatalogEntryType.COMMUNITY_AMPS) {
      setCatalogEntryType(CatalogEntryType.COMMUNITY_AMPS);
    } else if (location.pathname === '/cloudera' && catalogEntryType !== CatalogEntryType.CLOUDERA_AMPS) {
      setCatalogEntryType(CatalogEntryType.CLOUDERA_AMPS);
    }  else if (location.pathname === '/huggingface' && catalogEntryType !== CatalogEntryType.HUGGING_FACE) {
      setCatalogEntryType(CatalogEntryType.HUGGING_FACE);
    }
  }, [location]);

  const onSelect = (type: CatalogEntryType) => {
    setCatalogEntryType(type);
    const path = CatalogEntryTypeMap[type];
    navigate(`/${path}`);
  }

  return (
    <>
      <Header onSelect={onSelect} catalogEntryType={catalogEntryType} />
      <AppliedPrototypesContainer catalogEntryType={catalogEntryType} />
    </>
  );
}

export default AppliedPrototypesPage;
